export default __webpack_public_path__ + "static/ak-cached/24h/media/cinemax.941e374c.png";